import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    sharedToolbarActionMenu: {
      "& .MuiMenu-paper": {
        maxHeight: "337px",
        minWidth: "211px"
      },
      ".action-disabled": {
        color: colors.textDisabled,
        "&:hover": {
          background: "unset"
        }
      }
    },
    sharedToolbarActionListChoice: {
      background: colors.white,
      color: colors.blue700
    }
  }) as CSSObject;
